import BaseReducer from "./BaseReducer";

class CustmerReviewReducer extends BaseReducer {
  domain = "CustomerReview";
  type = "Modal";

  initialState = {
    open: false,
    inEditMode: false,
    reviewCompleted: false,
    venueEnterCounts: [],
    venueEnterTimes: [],
    form: {
      enteredVenue: null,
      venueEnterCountId: null,
      venueEnterTimeId: null,
      behaviourChanged: null,
      behaviourComments: null,
      atRisk: null,
      atRiskMeasures: null,
      anotherReview: null,
      nextReviewDate: null,
      barCustomer: null,
    },
    errors: [],
    selectedRecord: {
      id: null,
    },
    selectedReview: null,
  };
}

const reducer = new CustmerReviewReducer();

export default reducer;
